import React, { FC, useEffect, useState } from 'react';
import { Col, message, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import { api, endpoints } from '../../api';
import {
  BlueLayout,
  CustomButton,
  FormBlock,
  FormInput,
  PagesContainerUI,
  ValidatorFormItem,
} from '../../styles/styled';
import { emailRegExp, lastNameRegExp, patronymicRegExp, userNameRegExp } from '../../utils/patterns';
import { NmsMemberType } from '../NmsMembers/types';
import { NmsMemberInputType } from './types';

export type CreateNmsMemberProps = {
  editNms?: boolean;
  currentNms?: NmsMemberType | null;
  handleRefreshNmsData?: () => Promise<void>;
};

export const CreateNmsMember: FC<CreateNmsMemberProps> = ({ editNms, currentNms, handleRefreshNmsData }) => {
  const [memberInputsState, setMemberInputsState] = useState<NmsMemberInputType>({});
  const navigate = useNavigate();
  const [changesState, setChangesState] = useState<NmsMemberInputType | null>(null);

  const createUser = () => {
    api
      .post(endpoints.createUser(), {
        ...memberInputsState,
        roles: ['ROLE_NMS_MEMBER'],
        enabled: true,
        password: '',
      })
      .then(() => {
        message.success('Член нмс успешно создан');
        navigate(-1);
      })
      .catch(() => message.error('Ошибка при создании члена НМС'));
  };

  useEffect(() => {
    if (currentNms) setMemberInputsState(currentNms);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editNms]);

  useEffect(() => {
    if (editNms) {
      setChangesState(memberInputsState);
    }
  }, [editNms, memberInputsState]);

  const updateUser = () => {
    if (
      currentNms &&
      lastNameRegExp.test(editNms ? changesState?.lastname || '' : memberInputsState?.lastname || '') &&
      userNameRegExp.test(editNms ? changesState?.firstname || '' : memberInputsState?.firstname || '') &&
      patronymicRegExp.test(editNms ? changesState?.patronymic || '' : memberInputsState?.patronymic || '')
    ) {
      api
        .put(endpoints.getUserById(currentNms?.id), changesState)
        .then(() => {
          message.success('Данные успешно обновлены');
          handleRefreshNmsData && handleRefreshNmsData();
        })
        .catch(() => message.error('Произошла ошибка при обновлении данных'));
    }
  };

  return (
    <PagesContainerUI>
      {!editNms && <BlueLayout padding="40px 0 15px 0">Добавление члена НМС</BlueLayout>}
      <FormBlock padding="30px" white>
        <Row gutter={[20, 20]}>
          <Col span={8}>
            <ValidatorFormItem
              validator={
                !lastNameRegExp.test(editNms ? changesState?.lastname || '' : memberInputsState?.lastname || '')
              }
              redstar
            >
              <div className="text">Фамилия</div>
              <FormInput
                value={editNms ? changesState?.lastname : memberInputsState?.lastname}
                onChange={(e) => setMemberInputsState({ ...memberInputsState, lastname: e.target.value })}
              />
            </ValidatorFormItem>
          </Col>
          <Col span={8}>
            <ValidatorFormItem
              validator={
                !userNameRegExp.test(editNms ? changesState?.firstname || '' : memberInputsState?.firstname || '')
              }
              redstar
            >
              <div className="text">Имя</div>
              <FormInput
                value={editNms ? changesState?.firstname : memberInputsState?.firstname}
                onChange={(e) => setMemberInputsState({ ...memberInputsState, firstname: e.target.value })}
              />
            </ValidatorFormItem>
          </Col>
          <Col span={8}>
            <ValidatorFormItem
              validator={
                !patronymicRegExp.test(editNms ? changesState?.patronymic || '' : memberInputsState?.patronymic || '')
              }
              redstar
            >
              <div className="text">Отчество</div>
              <FormInput
                value={editNms ? changesState?.patronymic : memberInputsState?.patronymic}
                onChange={(e) => setMemberInputsState({ ...memberInputsState, patronymic: e.target.value })}
              />
            </ValidatorFormItem>
          </Col>
          <Col span={8}>
            <ValidatorFormItem
              validator={!emailRegExp.test(editNms ? changesState?.email || '' : memberInputsState?.email || '')}
              redstar
            >
              <div className="text">E-mail</div>
              <FormInput
                value={editNms ? changesState?.email : memberInputsState?.email}
                onChange={(e) => setMemberInputsState({ ...memberInputsState, email: e.target.value })}
              />
            </ValidatorFormItem>
          </Col>
        </Row>
        <div className="to-center">
          <CustomButton onClick={() => (editNms ? updateUser() : createUser())}>Сохранить</CustomButton>
        </div>
      </FormBlock>
    </PagesContainerUI>
  );
};
